import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const UserListAPI = async (setUsersList, setUserCount, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/users?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.users.data);
        
        setUsersList(response.data.users.data);
        setUserCount(response.data.usercount);
        //return response;

        setLoading(false);

        if(response.data.users.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.totalcount / perpagedata);

            console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        //console.error("Error in user list:", error);
        setLoading(false);
    }
}

export const getStateListAPI = async (setStateList, setLoading) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/setting/statelist");

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setStateList(response.data.data);
        setLoading(false);
    }
    catch(error)
    {
        //console.error("Error in state list:", error);
        setLoading(false);
    }
}

export const getIndustryTypeAPI = async (setIndustryList, setLoading) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/setting/domains");

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setIndustryList(response.data.data);
        setLoading(false);
    }
    catch(error)
    {
        //console.error("Error in user list:", error);
        setLoading(false);
    }
}

export const saveUserDataAPI = async (params, setLoading, resetUserForm, navigate) =>{

    setLoading(true);

    try
    {
        const response = await baseapi.post("/api/admin/user/add", params);

        //console.log("Data saved successfully", response);
        setLoading(false);

        if(response.data.code == 200)
        {
            //console.log("Here Step 1");
            successMesg(response.data.mesg);
            resetUserForm();
            navigate('/admin/users');
        }
        else if(response.data.code == 400)
        {
            //console.log("Here Step 2");
            errorMesg(response.data.mesg);    
        }
    }
    catch(error)
    {
        //console.error("Error in save user:", error);
        setLoading(false);
        errorMesg(error.data.mesg);
    }
}

export const editUserdataAPI = async (userid, setTxtUsername, setTxtPasswd, setTxtName, setTxtEmail, setTxtContact, setTxtAcname, setTxtState, setTxtIndustryType, setTxtUsertype, setLoading) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/user/edit/" + userid);

        //console.log("Data got successfully", response.data);
        //console.log("Username: ", response.data.code);
        
        setTxtUsername(response.data.data.username);
        setTxtName(response.data.data.name);
        setTxtEmail(response.data.data.email);
        setTxtContact(response.data.data.contact);
        setTxtUsertype(response.data.data.role_id);
        setTxtAcname(response.data.data.accountdata.name);
        setTxtState(response.data.data.accountdata.location);
        setTxtIndustryType(response.data.data.accountdata.domain_type);
        setLoading(false);
    }
    catch(error)
    {
        //console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const updateUserDataAPI = async (params, setLoading, navigate) =>{

    setLoading(true);

    try
    {
        const response = await baseapi.post("/api/admin/user/update", params);

        //console.log("Data saved successfully", response);
        setLoading(false);

        if(response.data.code == 200)
        {
            //console.log("Here Step 1");
            successMesg(response.data.mesg);
            navigate('/admin/users');
        }
        else if(response.data.code == 400)
        {
            //console.log("Here Step 2");
            errorMesg(response.data.mesg);    
        }
    }
    catch(error)
    {
        //console.error("Error in save user:", error);
        setLoading(false);
        errorMesg(error.data.mesg);
    }
}

export const deleteUserdataAPI = async (deleteuserid, setLoading, setShowModal, setIsUserDelete) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/user/delete/" + deleteuserid);

        //console.log("Data got successfully", response.data);
        //console.log("Username: ", response.data.code);
        
        if(response.data.code == 200)
        {
            setShowModal(false);

            successMesg(response.data.mesg);

            setLoading(true);

            setIsUserDelete(true);
        }
        else
        {
            setShowModal(false);

            errorMesg(response.data.mesg);
        }
    }
    catch(error)
    {
        //console.error("Error in user list:", error);
        //setLoading(false);
        setShowModal(false);
        //errorMesg(error);
    }
}

export const UserTrackListAPI = async (setUserTrackList, setTrackCount, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/user-tracking-log?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.datalist.data);
        
        setUserTrackList(response.data.datalist.data);
        setTrackCount(response.data.datalistcount);
        //return response;

        setLoading(false);

        if(response.data.datalist.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.datalistcount / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        //console.error("Error in user list:", error);
        setLoading(false);
    }
}

export const ActivityLogAPI = async (setActivityLogList, setLogCount, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/user/activity-log?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.datalist.data);
        
        setActivityLogList(response.data.datalist.data);
        setLogCount(response.data.datalistcount);
        //return response;

        setLoading(false);

        if(response.data.datalist.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.datalistcount / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        //console.error("Error in user list:", error);
        setLoading(false);
    }
}